module.exports = __webpack_public_path__ + "static/img/phone.9dfbb2.png";